import { API_BASE } from '../config/api';

const authHeaders = (token) => ({ Authorization: `Bearer ${token}` });

const handleResponse = async (response, fallback) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || data.message || fallback);
  return data;
};

export const searchUsers = async ({ token, q, email, page = 1, limit = 10, scope = {} }) => {
  const query = (email || q || '').trim();
  const params = new URLSearchParams({ email: query, page: String(page), limit: String(limit) });
  if (scope.entityType && scope.entityId) {
    params.set('entityType', String(scope.entityType));
    params.set('entityId', String(scope.entityId));
  }
  if (scope.communityId) params.set('communityId', String(scope.communityId));
  if (scope.organizationId) params.set('organizationId', String(scope.organizationId));
  if (scope.clubId) params.set('clubId', String(scope.clubId));

  const response = await fetch(`${API_BASE}/api/users/search?${params.toString()}`, {
    headers: authHeaders(token),
  });
  return handleResponse(response, 'Unable to search users.');
};

export const searchAssignableUsers = searchUsers;

export const assignEntityRole = async ({ token, entityType, entityId, userId, email, role }) => {
  const response = await fetch(`${API_BASE}/api/admin/entities/${entityType}/${entityId}/assign-role`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders(token) },
    body: JSON.stringify({ userId, email, role }),
  });
  return handleResponse(response, 'Unable to assign role.');
};

export const assignScopedRole = async ({ token, userId, email, role, scope }) => {
  const response = await fetch(`${API_BASE}/api/roles/assign`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders(token) },
    body: JSON.stringify({ userId, email, role, scope }),
  });
  return handleResponse(response, 'Unable to assign role.');
};

export const fetchEntityMemberships = async ({ token, entityType, entityId, q = '', role = '', status = 'active', page = 1, limit = 25 }) => {
  const params = new URLSearchParams({ status, page: String(page), limit: String(limit) });
  if (q.trim()) params.set('q', q.trim());
  if (role) params.set('role', role);
  const response = await fetch(`${API_BASE}/api/admin/entities/${entityType}/${entityId}/memberships?${params.toString()}`, {
    headers: authHeaders(token),
  });
  return handleResponse(response, 'Unable to load memberships.');
};

export const archiveMembership = async ({ token, entityType, entityId, membershipId }) => {
  const response = await fetch(`${API_BASE}/api/admin/entities/${entityType}/${entityId}/memberships/${membershipId}/archive`, {
    method: 'POST', headers: authHeaders(token),
  });
  return handleResponse(response, 'Unable to archive membership.');
};

export const restoreMembership = async ({ token, entityType, entityId, membershipId }) => {
  const response = await fetch(`${API_BASE}/api/admin/entities/${entityType}/${entityId}/memberships/${membershipId}/restore`, {
    method: 'POST', headers: authHeaders(token),
  });
  return handleResponse(response, 'Unable to restore membership.');
};
